module.exports = __webpack_public_path__ + "img/button_tramites_externos.90b1e1f8.png";